export const categories = [
  { slug: "all", name: "全部", icon: "ri-grid-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-sword-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "bl", name: "耽美", icon: "ri-star-line" },
  { slug: "gl", name: "百合", icon: "ri-flower-line" },
];

export const comics = [
  {
    id: "solo-leveling",
    title: "我独自升级",
    author: "Chugong / DUBU",
    category: ["action", "fantasy"],
    categoryNames: ["动作", "奇幻"],
    rating: 9.7,
    views: 1280000,
    description: "十年前，世界各地出现了连接异次元与现实的「传送门」，随之觉醒的还有被称为「猎人」的超能力者。身为E级猎人的成振宇，在一次地下城探险中濒临死亡，却意外获得了神秘的「系统」，从此踏上成为最强猎人的道路。",
    chapters: 200,
    status: "已完结",
    updateDate: "2024-12-20",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20cover%20illustration%2C%20dark%20fantasy%20male%20warrior%20with%20glowing%20purple%20eyes%2C%20dramatic%20lighting%2C%20epic%20anime%20art%20style%2C%20intense%20atmosphere%2C%20cinematic%20composition%2C%20clean%20dark%20background%2C%20high%20quality%20digital%20art%2C%20professional%20manhwa%20cover&width=450&height=600&seq=solo-leveling-cover&orientation=portrait",
    tags: ["热血", "逆袭", "系统", "战斗"],
  },
  {
    id: "true-beauty",
    title: "女神降临",
    author: "Yaongyi",
    category: ["romance", "drama"],
    categoryNames: ["恋爱", "剧情"],
    rating: 9.5,
    views: 980000,
    description: "因为长相平凡而被欺负的林周京，通过化妆技巧变身为校园女神。然而她一直隐藏着素颜的秘密，直到遇到两个截然不同的男生——完美的校草李修豪和叛逆不羁的韩书俊，她的人生开始发生翻天覆地的变化。",
    chapters: 256,
    status: "已完结",
    updateDate: "2024-11-15",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20true%20beauty%20glamorous%20female%20character%20cover%2C%20romance%20makeup%20transformation%20theme%2C%20soft%20pink%20pastel%20aesthetic%2C%20elegant%20webtoon%20art%20style%2C%20beautiful%20female%20face%20closeup%2C%20gentle%20warm%20lighting%2C%20clean%20simple%20background&width=450&height=600&seq=true-beauty-cover&orientation=portrait",
    tags: ["校园", "化妆", "三角恋", "成长"],
  },
  {
    id: "lookism",
    title: "外貌至上主义",
    author: "朴泰俊",
    category: ["drama", "comedy"],
    categoryNames: ["剧情", "搞笑"],
    rating: 9.3,
    views: 1560000,
    description: "胖墩墩的高中生朴亨硕长期遭受校园霸凌，转学后却意外获得了另一具完美躯体——高大帅气的身体。白天他以俊美形象生活，夜晚则回归原本的身材。通过这双重人生，他逐渐看清了社会对外貌的偏见与真实。",
    chapters: 480,
    status: "连载中",
    updateDate: "2026-08-01",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20lookism%20cover%20illustration%2C%20two%20male%20characters%20contrasting%20appearance%2C%20handsome%20and%20ordinary%20looking%20side%20by%20side%2C%20modern%20school%20uniform%2C%20dramatic%20webtoon%20art%2C%20urban%20night%20background%2C%20high%20contrast%20lighting%2C%20professional%20cover%20design&width=450&height=600&seq=lookism-cover&orientation=portrait",
    tags: ["校园", "双面人生", "社会议题", "成长"],
  },
  {
    id: "omniscient-reader",
    title: "全知读者视角",
    author: "sing N song / Sleepy-C",
    category: ["fantasy", "action"],
    categoryNames: ["奇幻", "动作"],
    rating: 9.8,
    views: 1420000,
    description: "金独子是一名普通的上班族，也是网络小说《在灭亡世界生存的三种方法》的唯一忠实读者。当小说中的末日场景在现实中真实上演时，凭借对剧情的全知，他开始在这个崩坏的世界中挣扎求存。",
    chapters: 240,
    status: "连载中",
    updateDate: "2026-08-03",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20viewpoint%20cover%2C%20apocalyptic%20fantasy%20scene%2C%20male%20protagonist%20in%20dark%20urban%20setting%2C%20dramatic%20webtoon%20illustration%2C%20constellation%20sky%20background%2C%20epic%20cinematic%20style%2C%20cool%20dark%20tones%2C%20professional%20manhwa%20art&width=450&height=600&seq=omniscient-reader-cover&orientation=portrait",
    tags: ["末世", "小说穿越", "策略", "冒险"],
  },
  {
    id: "return-of-blade",
    title: "剑尊归来",
    author: "LEE Cheol-ho / Studio JHS",
    category: ["action", "fantasy"],
    categoryNames: ["动作", "奇幻"],
    rating: 9.6,
    views: 1100000,
    description: "天下第一剑客梅长秀在与魔教教主决战中同归于尽，魂魄却穿越到了现代。在这个科技主导的世界里，他重新拾起剑术，却发现现代社会中隐藏着不为人知的武学传承和新的威胁。",
    chapters: 180,
    status: "连载中",
    updateDate: "2026-08-02",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sword%20master%20return%20cover%2C%20martial%20arts%20swordsman%20in%20modern%20city%2C%20traditional%20and%20modern%20contrast%2C%20action%20webtoon%20art%20style%2C%20dynamic%20pose%20with%20sword%2C%20dramatic%20lighting%2C%20professional%20illustration%2C%20clean%20urban%20background&width=450&height=600&seq=return-of-blade-cover&orientation=portrait",
    tags: ["武侠", "穿越", "剑术", "热血"],
  },
  {
    id: "her-private-life",
    title: "她的私生活",
    author: "金成妍",
    category: ["romance"],
    categoryNames: ["恋爱"],
    rating: 9.2,
    views: 720000,
    description: "成德美是美术馆的首席策展人，工作上专业干练，私下却是一个狂热的偶像追星族。新上任的馆长莱恩·戈尔德发现了她的秘密，两人在一系列啼笑皆非的事件中逐渐靠近彼此的心。",
    chapters: 120,
    status: "已完结",
    updateDate: "2024-09-10",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20office%20love%20cover%2C%20elegant%20female%20art%20curator%2C%20sophisticated%20art%20gallery%20setting%2C%20romantic%20webtoon%20art%20style%2C%20soft%20warm%20lighting%2C%20beautiful%20illustration%2C%20clean%20minimal%20background&width=450&height=600&seq=her-private-life-cover&orientation=portrait",
    tags: ["职场", "追星", "浪漫", "喜剧"],
  },
  {
    id: "bastard",
    title: "该死的告白日",
    author: "Carnby Kim / 黄英灿",
    category: ["thriller", "romance"],
    categoryNames: ["悬疑", "恋爱"],
    rating: 9.4,
    views: 890000,
    description: "高中生金真有一个不为人知的秘密——他的父亲是一名连环杀人犯。当转学生尹秀雅对他表现出好感时，金真必须在保护秀雅不受父亲伤害和揭露真相之间做出选择。紧张刺激的校园悬疑爱情故事。",
    chapters: 94,
    status: "已完结",
    updateDate: "2024-07-22",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20bastard%20cover%2C%20dark%20suspense%20atmosphere%2C%20high%20school%20setting%20with%20ominous%20mood%2C%20male%20and%20female%20characters%20in%20shadow%2C%20psychological%20thriller%20webtoon%20style%2C%20dim%20lighting%2C%20tense%20composition%2C%20professional%20illustration&width=450&height=600&seq=bastard-cover&orientation=portrait",
    tags: ["悬疑", "校园", "惊悚", "爱情"],
  },
  {
    id: "admission-archive",
    title: "入学档案",
    author: "LEE Hye",
    category: ["romance", "drama"],
    categoryNames: ["恋爱", "剧情"],
    rating: 9.1,
    views: 650000,
    description: "以优异成绩考入名牌大学的徐智雅，却在校园里遇到了高中时的暗恋对象——那个让她心碎的人。在全新的环境中，她能否放下过去，开启崭新的人生篇章？温馨治愈的校园恋爱故事。",
    chapters: 88,
    status: "已完结",
    updateDate: "2024-05-18",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20college%20romance%20cover%2C%20female%20student%20on%20beautiful%20university%20campus%2C%20spring%20cherry%20blossom%20setting%2C%20warm%20youthful%20webtoon%20art%20style%2C%20soft%20natural%20lighting%2C%20romantic%20atmosphere%2C%20clean%20background%2C%20professional%20illustration&width=450&height=600&seq=admission-archive-cover&orientation=portrait",
    tags: ["校园", "初恋", "治愈", "成长"],
  },
  {
    id: "who-made-me-princess",
    title: "某天成为公主",
    author: "Plutus / Spoon",
    category: ["fantasy", "romance"],
    categoryNames: ["奇幻", "恋爱"],
    rating: 9.6,
    views: 1350000,
    description: "一觉醒来发现自己穿越成了小说中的公主——而且是被亲生父亲处死的悲情角色！为了改变命运，阿纳斯塔西娅用尽全力讨好冷酷的皇帝父亲，却意外发现了隐藏在帝国背后的惊天秘密。",
    chapters: 210,
    status: "连载中",
    updateDate: "2026-07-30",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20princess%20fantasy%20cover%2C%20beautiful%20female%20character%20in%20elegant%20royal%20dress%2C%20fantasy%20palace%20setting%2C%20sparkling%20magical%20atmosphere%2C%20romantic%20fairy%20tale%20webtoon%20art%2C%20soft%20warm%20golden%20lighting%2C%20clean%20illustration%2C%20professional%20cover&width=450&height=600&seq=who-made-me-princess-cover&orientation=portrait",
    tags: ["穿越", "宫廷", "父女", "奇幻"],
  },
  {
    id: "villains-destiny",
    title: "反派角色只有死亡结局",
    author: "Gwon Gyeoeul / SUOL",
    category: ["fantasy", "drama"],
    categoryNames: ["奇幻", "剧情"],
    rating: 9.5,
    views: 1180000,
    description: "大学生李惠仁穿越进了自己正在玩的一款恋爱模拟游戏中，却发现自己附身的不是女主角，而是游戏中注定死亡的恶役千金佩内洛普·埃卡特。所有选择都指向死亡，她该如何打破命运的枷锁？",
    chapters: 196,
    status: "连载中",
    updateDate: "2026-08-01",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20villainess%20fantasy%20cover%2C%20elegant%20female%20character%20in%20dark%20royal%20dress%2C%20gothic%20fantasy%20mansion%20background%2C%20dramatic%20webtoon%20illustration%2C%20mysterious%20atmosphere%2C%20deep%20rich%20colors%2C%20professional%20manhwa%20art%2C%20clean%20composition&width=450&height=600&seq=villains-destiny-cover&orientation=portrait",
    tags: ["穿越", "游戏", "恶役", "逆袭"],
  },
  {
    id: "crown-prince-disappeared",
    title: "世子消失了",
    author: "Kim Hee-sun / HAE MIN",
    category: ["thriller", "drama"],
    categoryNames: ["悬疑", "剧情"],
    rating: 9.3,
    views: 760000,
    description: "朝鲜王朝时期，世子在一夜之间离奇失踪，整个王宫陷入混乱。负责调查此案的年轻官员李世远发现，世子的消失与二十年前的一桩宫廷血案有着千丝万缕的联系。历史的谜团正一点点被揭开。",
    chapters: 135,
    status: "连载中",
    updateDate: "2026-07-28",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20historical%20manhwa%20cover%2C%20joseon%20dynasty%20palace%20scene%2C%20mysterious%20atmosphere%2C%20traditional%20Korean%20clothing%2C%20moonlit%20night%20setting%2C%20dramatic%20webtoon%20art%20style%2C%20dark%20and%20mysterious%20tones%2C%20professional%20illustration&width=450&height=600&seq=crown-prince-disappeared-cover&orientation=portrait",
    tags: ["历史", "宫廷", "悬疑", "古风"],
  },
  {
    id: "kill-husband",
    title: "杀死老公的100种方法",
    author: "LEE Sun-young",
    category: ["drama", "thriller"],
    categoryNames: ["剧情", "悬疑"],
    rating: 9.0,
    views: 830000,
    description: "结婚五年的韩智恩发现丈夫出轨后，每天都在脑中演练各种「意外」让丈夫消失的方法。然而某天，丈夫真的死了，而她成了最大的嫌疑人。她必须证明自己的清白，同时揭开丈夫死亡的真相。",
    chapters: 78,
    status: "已完结",
    updateDate: "2024-10-05",
    coverUrl: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20drama%20cover%2C%20mysterious%20female%20character%20with%20dark%20expression%2C%20domestic%20suspense%20atmosphere%2C%20dramatic%20webtoon%20illustration%2C%20dim%20indoor%20lighting%2C%20tense%20mood%2C%20clean%20composition%2C%20professional%20art&width=450&height=600&seq=kill-husband-cover&orientation=portrait",
    tags: ["婚姻", "悬疑", "反转", "女性"],
  },
];

export const hotComics = comics.filter(c => c.rating >= 9.4).slice(0, 8);

export const latestUpdates = [...comics].sort((a, b) => {
  return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
}).slice(0, 8);

export const faqs = [
  {
    question: "韩国漫画网上的漫画都是免费的吗？",
    answer: "是的，韩国漫画网上的所有漫画资源均免费向读者开放，无需注册即可在线阅读。我们致力于为广大韩漫爱好者提供优质的阅读体验，让每一位读者都能畅享好看的韩国漫画。",
  },
  {
    question: "网站多久更新一次漫画章节？",
    answer: "我们与多家韩国漫画平台保持同步更新，热门连载漫画通常每周更新1-2次。您可以关注本站的「最近更新」栏目，随时了解最新上架的韩漫章节。",
  },
  {
    question: "在手机上可以阅读韩漫吗？",
    answer: "当然可以！韩国漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。",
  },
  {
    question: "如何查找我想看的漫画？",
    answer: "您可以通过首页的分类导航按类型筛选漫画，也可以使用搜索功能直接查找漫画名称。我们还提供了「热门推荐」和「最近更新」栏目，方便您发现更多好看的韩国漫画。",
  },
  {
    question: "网站上的漫画画质怎么样？",
    answer: "我们提供的漫画均为高清版本，图片清晰细腻，让您不会错过画面中的任何一个细节。所有漫画都经过专业优化，在保证画质的同时兼顾加载速度。",
  },
  {
    question: "无遮韩漫大全是什么意思？",
    answer: "「无遮」指的是漫画内容完整呈现，无删减、无遮挡。我们尊重原作者的创作，为读者提供最原汁原味的韩国漫画阅读体验。所有内容均来自正版授权渠道。",
  },
];

export const aboutInfo = {
  brandName: "韩国漫画网",
  slogan: "好看的韩国漫画，尽在韩国漫画网",
  intro: "韩国漫画网成立于2023年，是国内领先的韩国漫画在线阅读平台。我们专注于收集和整理优质的韩国漫画资源，致力于为中文读者打造一个内容丰富、界面友好的韩漫阅读社区。无论是热门的连载韩漫还是经典完结作品，您都能在这里一站式畅读。",
  features: [
    { title: "海量资源", description: "收录数千部韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑等各大类型，持续更新中" },
    { title: "高清画质", description: "所有漫画均为高清版本，精心优化图片质量，为您呈现每一格的精彩细节" },
    { title: "免费阅读", description: "全部漫画资源免费开放，无需付费订阅，让每一位韩漫爱好者都能畅享阅读乐趣" },
    { title: "多端适配", description: "网站采用响应式设计，完美兼容手机、平板和电脑，随时随地畅读韩漫" },
    { title: "更新迅速", description: "与韩方保持同步更新，热门连载漫画第一时间上架，让您追更不落伍" },
    { title: "界面友好", description: "简洁直观的操作界面，智能分类和搜索功能，帮您快速找到想看的漫画" },
  ],
  testimonials: [
    { name: "漫画迷小王", text: "终于找到了一个免费又好用的韩漫网站！画质超棒，更新也很快，每天都在这里追更。强烈推荐！", rating: 5 },
    { name: "追漫达人", text: "分类很清晰，查找漫画特别方便。无遮版看着就是爽，这才是真正的原汁原味韩漫体验！", rating: 5 },
    { name: "夜读少女", text: "手机浏览体验非常流畅，界面干净没有弹窗广告，阅读体验满分。已经推荐给身边所有喜欢看韩漫的朋友了。", rating: 5 },
    { name: "资深漫评人", text: "网站的漫画库相当丰富，很多小众的韩漫也收录了。翻译质量也不错，读起来很顺畅，收藏了！", rating: 4 },
    { name: "佛系读者", text: "最喜欢免费阅读这个点，其他平台都要付费或者看广告，这里真的是纯粹的阅读享受。良心网站！", rating: 5 },
    { name: "每日一漫", text: "更新速度让人惊喜，刚在韩国连载的漫画这边很快就有了。追更体验一流，已经离不开这个网站了。", rating: 5 },
  ],
};